import { useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";
import { isArray } from "lodash";
import apiInputService from "services/apiInputService"



const fetchSubcontractor = async (id: string) => {
    const { data } = await apiInputService.get("/subcontractor/" + id);
    
    return isArray(data) ? data[0] : data;
};

export const useSubcontractor = (id: string) => {
    const { subscription } = useSubscription();

    return useQuery(["subcontractors", subscription?.subscriptionId, id], ()=> fetchSubcontractor(id), {
        refetchOnWindowFocus: true,
        enabled: !!subscription?.subscriptionId && !!id,
    });

}